import { Button } from '@neo/index'
import { Typography } from '@neo/primitives/typography'

import { useSendMessage } from './use-send-message'

interface MessageButtonsProps {
  buttons: Array<{ title: string; id: string }>
  isLastChunk: boolean
}

export const MessageButtons = ({ buttons, isLastChunk }: MessageButtonsProps) => {
  const { sendMessage, isSending } = useSendMessage()

  if (!buttons || buttons.length === 0) return null

  const handleButtonClick = (buttonTitle: string) => {
    if (!isSending) sendMessage(buttonTitle)
  }

  return (
    <div className="flex min-w-0 flex-wrap gap-2">
      {buttons.map((button) => (
        <Button
          variant="outline"
          key={button.id}
          disabled={!isLastChunk || isSending}
          data-testid={`button-${button.id}`}
          onClick={() => handleButtonClick(button.title)}
          type="button"
          className="h-auto max-w-full whitespace-normal py-2 font-inter tracking-normal normal-case"
        >
          <Typography
            variant="S/400"
            className="text-foreground break-words [overflow-wrap:anywhere]"
          >
            {button.title}
          </Typography>
        </Button>
      ))}
    </div>
  )
}
